import React, { createContext, useContext } from "react";

// Phase 19 V1.0 slimming (2026-09). One switch, read from GET /api/config/public
// (`product_mode`), with REACT_APP_PRODUCT_MODE as the pre-load fallback; the
// backend value wins. "collectives" narrows what is LINKED — every route still
// resolves, so QR posters and bookmarks behave exactly as before.

export const ProductModeContext = createContext("full");

export const envProductMode = () =>
  (process.env.REACT_APP_PRODUCT_MODE || "").toLowerCase() === "collectives" ? "collectives" : "full";

const HIDDEN_PREFIXES = [
  "/opportunities", "/post-opportunity", "/discover", "/explore", "/log-hours", "/leaderboard",
  "/teams", "/analytics", "/partners", "/for-professionals", "/pathways", "/impact", "/wrapped", "/o/",
];

// Kept even in collectives mode: help requests and collective-scoped hosting/hours.
const KEPT = ["/opportunities?type=help", "/post-opportunity?collective=", "/log-hours?opportunity="];

export function isHiddenPath(path, mode) {
  if (mode !== "collectives" || !path) return false;
  if (KEPT.some((k) => path.startsWith(k))) return false;
  return HIDDEN_PREFIXES.some((p) => path === p || path.startsWith(p));
}

export function useProductMode() {
  const mode = useContext(ProductModeContext);
  const isCollectives = mode === "collectives";
  return {
    mode,
    isCollectives,
    isFull: !isCollectives,
    hidden: (path) => isHiddenPath(path, mode),
    // Filter helper for link lists: keeps anything not hidden.
    links: (items, key = "to") => items.filter((i) => !isHiddenPath(i[key], mode)),
  };
}
